import { render, staticRenderFns } from "./aliPlayer.vue?vue&type=template&id=25312a0e&scoped=true"
import script from "./aliPlayer.vue?vue&type=script&lang=js"
export * from "./aliPlayer.vue?vue&type=script&lang=js"
import style0 from "./aliPlayer.vue?vue&type=style&index=0&id=25312a0e&prod&lang=css"
import style1 from "./aliPlayer.vue?vue&type=style&index=1&id=25312a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25312a0e",
  null
  
)

export default component.exports